import { loadQuery } from 'react-relay';

import RelayEnvironment from 'lib/utils/relay';

import { COUNTRIES_QUERY } from 'services/country/country.relay.services';
import { countryCountriesQuery } from 'services/country/__generated__/countryCountriesQuery.graphql';

import { getUserId } from 'lib/utils/authentication';
import { userProfileQuery } from 'services/user/__generated__/userProfileQuery.graphql';
import { USER_PROFILE_QUERY } from 'services/user/user.relay.services';
import { profileSpecialitiesQuery } from 'services/profile/__generated__/profileSpecialitiesQuery.graphql';
import { GET_SPECIALITIES_QUERY } from 'services/profile/profile.relay.services';

export const ApplicationPreloadData = () => {
  const userId = getUserId();

  /**
   * Return
   */
  return {
    countriesQueryRef: loadQuery<countryCountriesQuery>(
      RelayEnvironment,
      COUNTRIES_QUERY,
      { first: 1000 },
      { fetchPolicy: 'store-or-network' },
    ),
    userProfileRef: loadQuery<userProfileQuery>(RelayEnvironment, USER_PROFILE_QUERY, {
      id: userId,
      skip: !userId,
    }),
    specialitiesQueryRef: loadQuery<profileSpecialitiesQuery>(
      RelayEnvironment,
      GET_SPECIALITIES_QUERY,
      { first: 1000, ordering: [{ sort: 'NAME', direction: 'ASC' }] },
      {
        fetchPolicy: 'store-or-network',
      },
    ),
  };
};

export type ApplicationPreloadDataType = ReturnType<typeof ApplicationPreloadData>;
